const multiselect = {
  root: {
    border: '.5px solid {gray.scale.500}',
    borderColor: '{gray.scale.500}',
    transitionDuration: '0.2s',
    borderRadius: '{form.field.border.radius}',
    minWidth: '16.5rem',
    placeholderColor: '{form.field.placeholder.color}',
    padding: '{form.field.padding.y} {form.field.padding.x}',
    height: '{form.field.height}',
  },
  list: {
    header: {
      padding: '{spacing.ss} {spacing.xs}',
    },
  },
  optionGroup: {
    background: '{list.option.group.background}',
    color: '{list.option.group.color}',
    fontWeight: '{list.option.group.font.weight}',
    padding: '0.75rem 0.5rem',
  },
  overlay: {
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.border.color}',
    borderRadius: '{overlay.select.border.radius}',
    color: '{overlay.select.color}',
    shadow: '{overlay.select.shadow}',
    minWidth: '200px',
  },
  option: {
    focusBackground: '{list.option.focus.background}',
    selectedBackground: '{list.option.selected.background}',
    selectedFocusBackground: '{list.option.selected.focus.background}',
    color: '{list.option.color}',
    focusColor: '{list.option.focus.color}',
    selectedColor: '{list.option.selected.color}',
    selectedFocusColor: '{list.option.selected.focus.color}',
    padding: '{spacing.ss} {spacing.xs}',
    borderRadius: '{list.option.border.radius}',
    height: '{list.option.height}',
    gap: '{spacing.xs}',
  },
  chip: {
    margin: '3px',
  },
  clearIcon: {
    color: '{form.field.icon.color}',
    right: '1.8rem',
  },
  dropdown: {
    width: '2.5rem',
  },
  colorScheme: {
    light: {
      root: {
        background: '{white}',
        hoverBorderColor: '{form.field.hover.border.color}',
        focusBorderColor: '{form.field.focus.border.color}',
      },
      dropdown: {
        color: '{form.field.icon.color}',
      },
    },
  },
};

export default multiselect;
